module.exports = __webpack_public_path__ + "static/why-is-there-an-indian-on-my-cake_2008-a3f59e8800ade8bc34a6ac8eb073ffd9.jpg";